"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processAssetWithExisting = exports["default"] = void 0;
var _constants = require("../constants");
var _functions = require("./functions");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable @typescript-eslint/indent */ /* eslint-disable no-param-reassign */
var Additions = [_constants.AnnotationTypes.Addition, _constants.AnnotationTypes.Addition_v2];
var processAssetWithExisting = function processAssetWithExisting(_ref) {
  var asset = _ref.asset,
    assets = _ref.assets,
    contentResource = _ref.contentResource,
    isDelete = _ref.isDelete,
    showFullContent = _ref.showFullContent,
    generateDynamicAnnotationName = _ref.generateDynamicAnnotationName,
    processAdditions = _ref.processAdditions,
    extractSnippetContent = _ref.extractSnippetContent;
  var subType = asset.subType,
    panelId = asset.panelId,
    type = asset.type,
    correct = asset.correct,
    _id = asset._id,
    text = asset.text;
  var snippet = subType === _constants.AnnotationTypes.Snippet && isDelete ? null : assets.find(function (a) {
    return a.panelId === panelId && a.subType === _constants.AnnotationTypes.Snippet;
  });

  // If this resource is a Provision type and is updating to be correct
  // we need to clear the other correct Provision resources
  if (!isDelete && type === _constants.ResourceItemTypes.Provision && correct) {
    assets.filter(function (r) {
      return r.type === _constants.ResourceItemTypes.Provision && r.correct;
    }).forEach(function (r) {
      return delete r.correct;
    });
  }
  var baseAnnotation = (0, _functions.isBaseAnnotation)(asset);
  var offset = 0;
  var length = 0;
  var isAddition = Additions.includes(subType);
  var timelineResource = _objectSpread({}, asset);
  var originalStartIndex;
  var index = assets.findIndex(function (r) {
    return r._id === _id;
  });
  if (index > -1) {
    if (!isDelete) {
      timelineResource = _objectSpread(_objectSpread({}, assets[index]), asset);
      if (isAddition) {
        var _assets$index$text;
        originalStartIndex = assets[index].startIndex;
        length = ((_assets$index$text = assets[index].text) === null || _assets$index$text === void 0 ? void 0 : _assets$index$text.length) || 0;
        offset = ((text === null || text === void 0 ? void 0 : text.length) || 0) - length;
        timelineResource.name = timelineResource.text;
      }
      assets[index] = timelineResource;
    } else {
      assets.splice(index, 1);
      if (isAddition) {
        length = (text === null || text === void 0 ? void 0 : text.length) || 0;
        offset = length * -1;
      }
    }
  } else if (!isDelete) {
    var name =
    // eslint-disable-next-line no-nested-ternary
    type === _constants.ResourceItemTypes.Answer ? timelineResource.name : timelineResource.name || isAddition ? text : "".concat(subType, " ").concat(assets.length + 1);
    if (isAddition) {
      length = (text === null || text === void 0 ? void 0 : text.length) || 0;
      offset = length;
    }
    if (subType === _constants.AnnotationTypes.Snippet) {
      snippet = timelineResource;
    }
    if (baseAnnotation && !showFullContent && contentResource && snippet && subType !== _constants.AnnotationTypes.Snippet && contentResource.version === 2 && !(0, _functions.isEmpty)(timelineResource.startIndex) && !(0, _functions.isEmpty)(timelineResource.endIndex) && !(0, _functions.isEmpty)(snippet.startIndex) && !(0, _functions.isEmpty)(snippet.endIndex)) {
      // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
      timelineResource.startIndex += snippet.startIndex;
      // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
      timelineResource.endIndex += snippet.startIndex;
    }
    if ((0, _functions.isDynamicNameAnnotation)(timelineResource) && contentResource && generateDynamicAnnotationName) {
      name = generateDynamicAnnotationName(timelineResource, contentResource);
    }
    assets.push(_objectSpread(_objectSpread({}, timelineResource), {}, {
      name: name
    }));
  }
  if (isAddition) {
    if (baseAnnotation) {
      var resourcesToDelete = [];
      var _endIndex = (timelineResource.startIndex || 0) + (length ? length - 1 : 0);
      var assetExists = index > -1;
      var shiftingBack = assetExists && (originalStartIndex || -1) > (timelineResource.startIndex || -1);
      var toProcess = [];
      var answerEdits = [];
      assets.forEach(function (a) {
        if (a.panelId === panelId) {
          if (a._id !== _id) {
            if (a.type === _constants.ResourceItemTypes.Annotation) {
              toProcess.push(a);
            }
          }
        } else if (a.type === _constants.ResourceItemTypes.Answer && a.answerEdits) {
          answerEdits.push.apply(answerEdits, _toConsumableArray(a.answerEdits));
        }
      });
      toProcess.forEach(function (pa) {
        var deleteStartWithin = false;
        var deleteEndWithin = false;
        var isAnswerBase = pa.subType === _constants.AnnotationTypes.AnswerBase;
        var startIndex_pa = pa.startIndex || -1;
        var endIndex_pa = pa.endIndex || -1;
        var startIndex_tr = timelineResource.startIndex || -1;
        var lengthOffset = length ? length - 1 : 0;
        var endBefore = originalStartIndex + lengthOffset;
        var endAfter = startIndex_tr + lengthOffset;
        var startBefore = originalStartIndex;
        var startAfter = startIndex_tr;
        var shifted = false;
        var startConflict = false;
        var endConflict = false;
        var logs = [];
        var outputLog = false;
        if (assetExists && !isDelete) {
          if (!shiftingBack) {
            if (startIndex_pa >= endBefore && startIndex_pa <= endAfter) {
              pa.startIndex = startIndex_pa - length;
              shifted = true;
              startConflict = true;
              logs.push(['shift forward, start conflict', endBefore, endAfter, startIndex_pa, pa.startIndex, startIndex_pa >= endBefore, startIndex_pa <= endAfter, endIndex_pa, pa.endIndex, endIndex_pa >= endBefore, endIndex_pa <= endAfter, length]);
            }
            if (endIndex_pa >= startBefore && endIndex_pa < startAfter || !Additions.includes(pa.subType) && endIndex_pa >= endBefore && endIndex_pa < endAfter) {
              pa.endIndex = endIndex_pa - length;
              shifted = true;
              endConflict = true;
              logs.push(['shift forward, end conflict', endBefore, endAfter, startIndex_pa, pa.startIndex, startIndex_pa >= endBefore, startIndex_pa <= endAfter, endIndex_pa, pa.endIndex, endIndex_pa >= startBefore, endIndex_pa < startAfter, length]);
            }
            if ((startConflict || endConflict) && Additions.includes(pa.subType) && pa.text) {
              var updatedStart = startIndex_tr;
              if (startConflict && endConflict) {
                updatedStart = startIndex_tr - pa.text.length;
              }
              var updatedEnd = updatedStart + lengthOffset;
              timelineResource.startIndex = updatedStart;
              timelineResource.endIndex = updatedEnd;
              logs.push(['shifted annotation was Addition, adjusting asset being updated', updatedStart, updatedEnd]);
            }
          } else {
            if (startIndex_pa <= startBefore && startIndex_pa >= startAfter) {
              pa.startIndex = startIndex_pa + length;
              shifted = true;
              startConflict = true;
              logs.push(['shift backward, start conflict', endBefore, endAfter, startIndex_pa, pa.startIndex, startIndex_pa >= endBefore, startIndex_pa <= endAfter, endIndex_pa, pa.endIndex, endIndex_pa >= endBefore, endIndex_pa <= endAfter, length]);
            }
            if (endIndex_pa <= startBefore && endIndex_pa >= startAfter) {
              pa.endIndex = endIndex_pa + length;
              shifted = true;
              endConflict = true;
              logs.push(['shift backward, end conflict', endBefore, endAfter, startIndex_pa, pa.startIndex, startIndex_pa >= endBefore, startIndex_pa <= endAfter, endIndex_pa, pa.endIndex, endIndex_pa >= endBefore, endIndex_pa <= endAfter, length]);
            }
          }
          if (shifted && outputLog) {
            console.log(logs, pa);
          }
        }
        if (!shifted && offset) {
          if (startIndex_pa > -1 && startIndex_tr > -1 && startIndex_pa >= startIndex_tr) {
            if (startIndex_pa <= _endIndex && isDelete) {
              deleteStartWithin = true;
            } else {
              pa.startIndex = startIndex_pa + offset;
              if (isAnswerBase) {
                answerEdits.forEach(function (ae) {
                  // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
                  ae.startIndex += offset;
                });
              }
            }
          }
          if (endIndex_pa > -1 && startIndex_tr > -1 && endIndex_pa >= startIndex_tr) {
            if (endIndex_pa <= _endIndex && isDelete) {
              deleteEndWithin = true;
            } else {
              pa.endIndex = endIndex_pa + offset;
              if (isAnswerBase) {
                answerEdits.forEach(function (ae) {
                  // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
                  ae.endIndex += offset;
                });
              }
            }
          }
        }
        if (deleteStartWithin && deleteEndWithin) {
          resourcesToDelete.push(pa);
        } else if (deleteStartWithin) {
          pa.startIndex = timelineResource.startIndex;
        } else if (deleteEndWithin && !(0, _functions.isEmpty)(timelineResource.endIndex)) {
          // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
          pa.endIndex = timelineResource.startIndex - 1;
        }
      });
      resourcesToDelete.forEach(function (r) {
        var assetIndex = assets.findIndex(function (tr) {
          return tr._id === r._id;
        });
        if (assetIndex > -1) {
          assets.splice(assetIndex, 1);
        }
      });
    }
    var additions = assets.filter(function (r) {
      if (r.panelId === panelId) {
        if (r.panelId === panelId && Additions.includes(r.subType)) {
          if (r._id !== _id || !isDelete) {
            return true;
          }
        }
      }
      return false;
    });
    if (processAdditions && contentResource && !processAdditions(additions, contentResource)) {
      contentResource.indexedContent = contentResource.originalIndexedContent;
    }
  }

  // Check for Snippet Annotation
  // and if it exists, re-apply the Snippet to the content
  if (snippet && contentResource) {
    if (extractSnippetContent && !(0, _functions.isEmpty)(snippet.startIndex) && !(0, _functions.isEmpty)(snippet.endIndex)) {
      contentResource.snippedContent = extractSnippetContent(
      // @ts-expect-error: ignore 'undefined' check (verified through isEmpty)
      snippet.startIndex, snippet.endIndex, contentResource.indexedContent);
    }
  } else if (contentResource) {
    delete contentResource.snippedContent;
  }
};
exports.processAssetWithExisting = processAssetWithExisting;
var _default = processAssetWithExisting;
exports["default"] = _default;